import Alpine from 'alpinejs';

Alpine.data('rule', (thickness, spaceBefore, spaceAfter) => ({
  thickness,
  spaceBefore,
  spaceAfter,
  
  get styles() {
    return {
      height: this.thickness + 'px',
      marginTop: this.spaceBefore + 'px',
      marginBottom: this.spaceAfter + 'px'
    };
  }
}));